import { useCallback, useEffect, useState } from 'react';
import { GridFilterModel, GridPaginationModel } from '@mui/x-data-grid';
import { InvoiceModel, InvoiceStatus } from 'models/InvoiceModel';
import useInvoices from 'modules/invoices/hooks/useInvoices';


const useInvoicesPaginated = (status: InvoiceStatus, payer: string, limit: number = 100) => {
    const [invoices, setInvoices] = useState<InvoiceModel[]>([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState<{page: number, filter: any[]}>({filter: [], page: 0});
    const { findInvoices } = useInvoices();

    const setPage = useCallback(({page}: GridPaginationModel) => {
        setLoading(true);
        setOptions(old => ({...old, page }));

        findInvoices({
            status,
            payer,
            page,
            filter: options.filter,
            limit,
        })
            .then(res => {
                setInvoices(res.data);
                setTotal(res.meta.total);
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line
    }, []);

    const setFilter = useCallback((filterModel: GridFilterModel) => {
        setLoading(true);
        setOptions({page: 0, filter: [ ...filterModel.items ] });

        findInvoices({
            status,
            payer,
            page: 0,
            filter: filterModel.items,
            limit,
        })
            .then(res => {
                setInvoices(res.data);
                setTotal(res.meta.total);
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setPage({page: 0, pageSize: 100});
        // eslint-disable-next-line
    }, []);

    return {
        invoices,
        total,
        loading,
        setPage,
        setFilter,
    };
};

export default useInvoicesPaginated;
